/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";

import { Grid, Paper, Button } from "@material-ui/core";
import { AuthContext } from "../../contexts/authContext";

import { useValidEmail } from "../../hooks/useValidEmail";
import { useHistory, Link } from "react-router-dom";
import {
  alertStyle,
  backgroundStyle,
  btnStyle,
  h3Style,
  inputStyle,
  logoStyle,
  paperStyle,
  pStyle,
} from "./styles";
import { Alert, FormControl, OutlinedInput } from "@mui/material";
import { PasswordType } from "interfaces/IPassType";
import { Header } from "components/Header/Header";

const ForgotPasswordEmail: React.FC = () => {
  /* States and context declaration */
  const { email, setEmail, emailIsValid } = useValidEmail(null);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  const onRecoverPressed = async (e: any) => {
    e.stopPropagation();
    if (email) {
      try {
        await authContext.sendCodeRecoverPassword(email.toLowerCase());
        history.push(`/CheckPassword/${email}/${PasswordType.RECOVERY}`);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
      }
    }
  };

  return (
    <>
      <Header showSettings={false} />
      <div style={backgroundStyle}>
      <Grid container justifyContent="center" alignContent="center">
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
          <Paper
            elevation={0}
            style={paperStyle}
          >
            <div style={ {margin: "0px auto"}}>
              <Grid style={logoStyle}>
                <h3 style={h3Style}>Forgot Password</h3>
                <p style={pStyle}>
                  Enter your email address below and we’ll send you a link to
                  reset your password
                </p>
                {genericErrorMessage != "" ? (
                  <Alert style={alertStyle} variant="outlined" severity="error">
                    Error: {genericErrorMessage}
                  </Alert>
                ) : null}
              </Grid>
              <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                  id="outlined-adornment-email"
                  size="small"
                  style={{ ...inputStyle, marginTop: "0" }}
                  type="text"
                  value={email}
                  error={emailIsValid != ""}
                  onChange={(e: any) => setEmail(e.target.value)}
                  placeholder="Email"
                />
              </FormControl>

              {/* <Typography style={TypographyStyle}>
              {" "}
              Have an account? <Link to="/SignIn"> Login</Link>
            </Typography> */}
            </div>
          </Paper>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={btnStyle}
            fullWidth
            disabled={emailIsValid != ""}
            onClick={(e) => {
              onRecoverPressed(e);
            }}
          >
            Submit
          </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ForgotPasswordEmail;
